import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('App is ready for offline use!');
  },
  onUpdate: () => {
    console.log('New content available.');
    // Surface a dismissible banner (see PWAUpdatePrompt) instead of a blocking
    // confirm + forced reload, so we never interrupt the user mid-search.
    window.dispatchEvent(new CustomEvent('pwa-update-available'));
  },
});